var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOneoWithdraw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#FDE0E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_627_51145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 11.7501H22V10.4001C22 9.55998 22 9.13993 21.8256 8.81905C21.6722 8.53679 21.4274 8.30731 21.1264 8.1635C20.7841 8 20.3361 8 19.44 8H8.56C7.66392 8 7.21587 8 6.87362 8.1635C6.57256 8.30731 6.32779 8.53679 6.17439 8.81905C6 9.13993 6 9.55998 6 10.4001V11.7501Z",
    fill: "#FFA6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 11.7501H6M8.8 18.5004H8.56C7.66392 18.5004 7.21587 18.5004 6.87362 18.3369C6.57256 18.1931 6.32779 17.9636 6.17439 17.6814C6 17.3605 6 16.9404 6 16.1003V10.4001C6 9.55998 6 9.13993 6.17439 8.81905C6.32779 8.53679 6.57256 8.30731 6.87362 8.1635C7.21587 8 7.66392 8 8.56 8H19.44C20.3361 8 20.7841 8 21.1264 8.1635C21.4274 8.30731 21.6722 8.53679 21.8256 8.81905C22 9.13993 22 9.55998 22 10.4001V16.1003C22 16.9404 22 17.3605 21.8256 17.6814C21.6722 17.9636 21.4274 18.1931 21.1264 18.3369C20.7841 18.5004 20.3361 18.5004 19.44 18.5004H19.2",
    stroke: "url(#paint0_linear_627_51145)",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3999 17.7499L13.9999 20M13.9999 20L11.5999 17.7499M13.9999 20V14.7498",
    stroke: "url(#paint1_linear_627_51145)",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_627_51145",
    x: 4.2002,
    y: 6.19922,
    width: 21.5996,
    height: 17.6016,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.0392157 0 0 0 0 0.109804 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_627_51145"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_627_51145",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_627_51145",
    x1: 6,
    y1: 8,
    x2: 22.2667,
    y2: 8.43091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_627_51145",
    x1: 16.3999,
    y1: 20,
    x2: 11.5177,
    y2: 19.9224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneoWithdraw);
export default __webpack_public_path__ + "static/media/OneoWithdraw.82b8f0ac5b39031fe092d0b01c27a9b5.svg";
export { ForwardRef as ReactComponent };